import availableHairColors from '../../../../../../../../../helpers/hairColorHelper'
import availableEthnicities from '../../../../../../../../../helpers/ethnicityHelper'
import { availableBarsRestaurantsJobTypes } from '../../../../../../../../../helpers/availableJobTypeHelper'
import pastJob from '../../../../../dto/pastJobs'
import media from '../../../../../dto/media'

export default function() {
    let medias = []
    for (let i = 1; i <= 4; i++) {
        let photo = Object.assign({}, media)
        photo.type = 'photo'

        medias.push(photo)
    }
    let video = Object.assign({}, media)
    video.type = 'video'
    medias.push(video)

    return {
        availableHairColors,
        availableEthnicities,
        availableBarsRestaurantsJobTypes,
        profile: {
            category: 'bars_restaurants',
            hairColor: null,
            ethnicity: null,
            fees: [],
            pastJobs: [{...pastJob}],
            media: medias,
            types: []
        },
        errors: {
            hairColor: null,
            ethnicity: null,
            fee: null,
            types: null,
            pastJobs: []
        },
        showCropper: false,
        showVideoInput: false,
        videoObj: null,
        croppingImage: null,
        videoError: null
    }
}
